import { t } from "@/i18n-js/instance";
import { EditorCollapsable } from "@circle-react-shared/BuilderUI/Editor/EditorCollapsable";
import { BoxModelInput } from "@circle-react-shared/Emails/VisualEmailBuilder/EditorFields/BoxModelField/BoxModelInput";

export const Padding = () => (
  <EditorCollapsable
    title={t("builder_ui.prop_type.styles.padding")}
    defaultOpen
  >
    <div className="flex flex-col px-6 py-4">
      <BoxModelInput
        type="padding"
        name="styles.padding"
        label={t("builder_ui.prop_type.styles.padding")}
      />
    </div>
  </EditorCollapsable>
);
